<div class="body-container">
    <div *ngIf="showHistoryButton">
        {{ 'version.create.dialog.reference.text' | translate }}
    </div>
    <div>
        <fieldset class="fieldset">
            <legend
                class="legend"
                data-cy="vessel-modal-repurpose-version-reference-label"
                *ngIf="showList || selectedVersion">
                {{ 'version.create.dialog.reference.legend' | translate }}
            </legend>
            <div class="input-container" (click)="showList = !showList" #listInput>
                <input
                    type="text"
                    class="name input"
                    data-cy="vessel-modal-repurpose-version-reference"
                    [ngStyle]="{
                        'font-weight': showHistoryButton ? '500' : 'unset',
                    }"
                    readonly
                    [(ngModel)]="selectedVersion.name" />
                <mat-icon
                    svgIcon="arrow-down"
                    class="icon"
                    [ngStyle]="{ transform: !showList ? 'rotate(180deg)' : '' }" />
            </div>
        </fieldset>

        <ng-container *ngIf="showList && versionsList?.length > 0">
            <div class="list-wrapper" #listContainer>
                <div class="list-container" data-cy="vessel-modal-repurpose-version-reference-list">
                    <div
                        *ngFor="let item of versionsList"
                        (click)="$event.stopPropagation(); handleVersionSelected(item)"
                        [ngClass]="{ highlighted: selectedVersion === item }"
                        class="list-item"
                        data-cy="vessel-modal-repurpose-version-reference-list-item">
                        {{ item.name }}
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="button" (click)="openVersionHistory()" *ngIf="showHistoryButton">
        {{ 'version.create.dialog.reference.button' | translate }}
    </div>
</div>
